const cosCdn = 'https://cos-pub.wenqing123.com/'
const functions = {
  /**
   * 返回cos资源地址
   */
  getResourceUrl: (path) => {
    return cosCdn + path
  },

  /**
   * 读取当前域名地址
   */
  getlocalBaseUrl: () => {
    let baseURL = ''
    if (!window.location.origin) {
      // 兼容IE，IE11版本下location.origin为undefined
      window.location.origin =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '')
    } else {
      baseURL = window.location.origin
    }
    return baseURL
  },

  /**
   * 加载cdn js资源
   */
  loadScript: (url, callback) => {
    const script = document.createElement('script')
    const fn = callback || function () {}
    script.type = 'text/javascript'
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null
          fn('success')
        }
      }
    } else {
      script.onload = function () {
        fn('success')
      }
      script.onerror = function () {
        fn('fail')
      }
    }
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)
  },

  /**
   *  键盘事件
   */
  handleKeyup: (event) => {
    console.log(event)
    const e = event || window.event
    if (!e) return
    const { keyCode } = e
    if (keyCode === 32) {
      console.log('我是空格键')
      // console.log(window.Player.isFullscreen())
    } else if (keyCode === 39) {
      console.log('我是前进键')
    } else if (keyCode === 37) {
      console.log('我是后退键')
    } else {
      return false
    }
    console.log(keyCode) // 对应的keycode
    // console.log(key) // 对应的键
  },

  // 将秒数转换为时分秒格式
  formatSeconds: (value) => {
    var theTime = parseInt(value) // 秒
    var middle = 0 // 分
    var hour = 0 // 小时

    if (theTime > 60) {
      middle = parseInt(theTime / 60)
      theTime = parseInt(theTime % 60)
      if (middle > 60) {
        hour = parseInt(middle / 60)
        middle = parseInt(middle % 60)
      }
    }
    var result = '' + parseInt(theTime) + '秒'
    if (middle > 0) {
      result = '' + parseInt(middle) + '分' + result
    }
    if (hour > 0) {
      result = '' + parseInt(hour) + '小时' + result
    }
    return result
  },

  // 获取秒级时间戳
  timestampSeconds: (time = null) => {
    if (!time) time = new Date()
    let tmp = Date.parse(time).toString()
    return tmp.substr(0, 10)
  },
}
export default functions
